import NoSsr from '@material-ui/core/NoSsr';
import React from 'react';
import { PageStrings } from '@alltrails/shared/utils/pageStringHelpers';
import { reorder } from '@alltrails/shared/utils/listHelpers';
import logError from 'utils/logError';
import { updateListPrivacy } from 'utils/requests/list_requests';
import { createPortal } from 'react-dom';
import PrivacyTrigger from '@alltrails/shared/components/PrivacyTrigger';
import LoadingSpinner from '@alltrails/shared/components/LoadingSpinner';
import isEqual from 'underscore/modules/isEqual';
import isEmpty from 'underscore/modules/isEmpty';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import { debounce } from 'debounce';
import Toggle from '../../../../../components/shared/Toggle';
import TrackResultCard from '../../../../../components/cards/TrackResultCard';
import TrailResultCard from '../../../../../components/cards/TrailResultCard';
import ListPrivacyToggle from '../../../../../components/search/ListPrivacyToggle';
import { StringConstantsMixin } from '../../mixins/shared/string_constants_mixin';
import { shallowCompare } from '../../../../../utils/compare';
import Button from '../../../../../components/shared/Button';
import { VISIBILITY_TO_OPTION, policyToRadioForm, LIST } from '../../../../../utils/privacy_policy_helpers';
import IndividualPrivacyModal from '../../../../../components/privacyPolicy/modals/IndividualPrivacyModal';

const createReactClass = require('create-react-class');

const itemHeight = 260; // height of item to be used in calculating # of visible items (including margins)
const renderableItemOffset = 1; // render more items using this offset than the current limit for better scrolling experience

const FullscreenSearchResultList = createReactClass({
  getInitialState() {
    return {
      visibleItemIndex: 0,
      // estimate before we know the scroll height
      renderableItems: 6,
      visibleItems: 6,
      loadItems: 6,
      animatedString: '...',
      uploadFormVisible: this.props.uploadFormVisible,
      refreshAds: false,
      results: this.props.results,
      h1Obj: this.props.h1Obj,
      customList: this.props.customList,
      showModal: false
    };
  },
  shouldComponentUpdate(nextProps, nextState) {
    return shallowCompare(this, nextProps, nextState, propKey => propKey !== 'resultCardFunctions');
  },
  componentDidMount() {
    this.handleResize();
    window.addEventListener('resize', debounce(this.handleResize, 200));
  },
  handleResize() {
    if (this.refs.scrollList) {
      const h = this.refs.scrollList.offsetHeight;
      const visibleItems = Math.ceil(h / itemHeight);
      this.setState({ renderableItems: visibleItems, visibleItems });
    }
  },
  // TODO: eventually migrate to static getDerivedStateFromProps()
  UNSAFE_componentWillReceiveProps(nextProps) {
    const nextState = {
      results: nextProps.results
    };
    // only update h1Obj if new h1Obj is valid
    if (nextProps.h1Obj) {
      nextState.h1Obj = nextProps.h1Obj;
    }
    // adjust scroll/renderableItems if new items in list
    if (nextProps.results && this.props.results) {
      const newIds = nextProps.results.map(result => result.ID);
      const oldIds = this.props.results.map(result => result.ID);
      if (!isEqual(newIds, oldIds)) {
        nextState.renderableItems = this.state.visibleItems;
        if (this.refs.scrollList) {
          this.refs.scrollList.scrollTop = 0;
        }
      }
    }
    this.setState(nextState);
  },
  componentWillUnmount() {
    clearInterval(this.timer);
  },
  onDragEnd(result) {
    if (!result.destination) {
      return;
    }

    const results = reorder(this.state.results, result.source.index, result.destination.index);
    const ids = results.map(r => r.ID);

    this.props.changeParentResultOrder(results, ids);
  },
  handleScroll() {
    const { renderableItems, visibleItems, results } = this.state;
    // Do nothing if all items have been rendered
    if (renderableItems >= results.length) {
      return;
    }
    // If space to scroll is less than the renderable offset, render another batch equal to the size of visible items
    const { scrollHeight, scrollTop, clientHeight } = this.refs.scrollList;
    const scrollBottom = scrollHeight - (scrollTop + clientHeight);
    if (scrollBottom < renderableItemOffset * itemHeight) {
      this.setState({ renderableItems: renderableItems + visibleItems });
    }
  },
  getResultLength() {
    return this.state.results ? this.state.results.length : 0;
  },
  onListPrivacyChange(isPrivate) {
    const customList = this.state.customList;
    customList.private = isPrivate;
    this.setState({ customList });
  },
  getListFunctionalityClasses() {
    let listFunctionalityClasses = '';
    if (this.props.showBottomButton) {
      listFunctionalityClasses += ' bottom-button';
    }
    if (this.props.handleResultsEditClick) {
      listFunctionalityClasses += ' float-delete-button';
    }
    return listFunctionalityClasses;
  },
  renderTrackResultCard(result, idx, dragHandleProps) {
    return (
      <TrackResultCard
        allowItemDelete={
          this.props.isEditing &&
          this.props.resultCardFunctions.allowAddRemove() &&
          this.props.resultCardFunctions.isItemInPageList(result.type, result.ID)
        }
        allowItemMoving={this.props.allowReordering}
        context={this.props.context}
        forcePhotoId={this.props.resultCardFunctions.forcePhotoId(result.type, result.ID)}
        handleCardClick={() =>
          (result.type == 'track' ? this.props.resultCardFunctions.handleTrackClick : this.props.resultCardFunctions.handleMapClick)(result)
        }
        handleFavoriteClick={() => this.props.listMethods.handleFavoriteClick(result.type, result.ID)}
        handleItemDeleteClick={() => this.props.resultCardFunctions.handleAddRemoveClick(result.type, result.ID)}
        idx={idx}
        isFavorite={this.props.listMethods.isFavorite(result.type, result.ID)}
        isMobileWidth={this.props.isMobileWidth}
        itemDeleteLabel={this.props.resultCardFunctions.getAddRemoveLabels().remove}
        key={`track-${result.ID}`}
        messagingChannel={this.props.messagingChannel}
        opaqueOverlay={this.props.isEditing}
        showFavoriteHeart={this.props.listMethods.showFavoriteHeart}
        tabletBrowser={this.props.context.tabletBrowser}
        track={result}
        dragHandleProps={dragHandleProps}
      />
    );
  },
  renderTrailResultCard(result, idx, dragHandleProps) {
    return (
      <TrailResultCard
        allowItemDelete={
          this.props.isEditing &&
          this.props.resultCardFunctions.allowAddRemove() &&
          this.props.resultCardFunctions.isItemInPageList(result.type, result.ID)
        }
        allowItemMoving={this.props.allowReordering}
        allowClickingCompletedBadge={this.props.resultCardFunctions.allowClickingCompletedBadge(result.type, result.ID)}
        context={this.props.context}
        handleItemDeleteClick={() => this.props.resultCardFunctions.handleAddRemoveClick(result.type, result.ID)}
        handleCardClick={() => this.props.resultCardFunctions.handleTrailClick(result)}
        handleCompletedBadgeClick={() => this.props.resultCardFunctions.handleCompletedBadgeClick(result.type, result.ID)}
        handleFavoriteClick={() => this.props.listMethods.handleFavoriteClick(result.type, result.ID, result.objectID)}
        handleLocationClick={this.props.resultCardFunctions.handleLocationClick}
        idx={idx}
        isCompleted={this.props.listMethods.isComplete(result.type, result.ID)}
        isFavorite={this.props.listMethods.isFavorite(result.type, result.ID)}
        isMobileWidth={this.props.isMobileWidth}
        isVerified={this.props.listMethods.isVerified(result.type, result.ID)}
        itemDeleteLabel={this.props.resultCardFunctions.getAddRemoveLabels().remove}
        key={`trail-${result.ID}`}
        messagingChannel={this.props.messagingChannel}
        opaqueOverlay={this.props.isEditing}
        showFavoriteHeart={this.props.listMethods.showFavoriteHeart}
        tabletBrowser={this.props.context.tabletBrowser}
        trail={result}
        trailUrl={this.props.resultCardFunctions.formatTrailUrl(result)}
        dragHandleProps={dragHandleProps}
      />
    );
  },
  renderSortableList() {
    const listFunctionalityClasses = this.getListFunctionalityClasses();
    return (
      <NoSsr>
        <DragDropContext onDragEnd={this.onDragEnd}>
          <Droppable droppableId="droppable">
            {provided => (
              <ul className={listFunctionalityClasses} {...provided.droppableProps} ref={provided.innerRef}>
                {this.state.results.map((result, idx) => {
                  const id = result.ID.toString();
                  return (
                    <Draggable key={id} draggableId={id} index={idx}>
                      {provided => (
                        <li ref={provided.innerRef} {...provided.draggableProps}>
                          {this.renderTrailOrTrackResultCard(result, idx, provided.dragHandleProps)}
                        </li>
                      )}
                    </Draggable>
                  );
                })}
                {provided.placeholder}
              </ul>
            )}
          </Droppable>
        </DragDropContext>
        {this.getResultLength() < 3 &&
          [PageStrings.EXPLORE_ALL_PAGE, PageStrings.EXPLORE_COMMUNITY_CONTENT_PAGE].includes(this.props.currentPage) &&
          this.props.noResultsObj}
      </NoSsr>
    );
  },
  renderTrailOrTrackResultCard(result, idx, dragHandleProps = null) {
    if (result.type === 'trail') {
      return this.renderTrailResultCard(result, idx, dragHandleProps);
    }
    if (result.type === 'track' || result.type === 'map') {
      return this.renderTrackResultCard(result, idx, dragHandleProps);
    }
  },
  renderEditButton() {
    if (isEmpty(this.state.results) || this.props.context?.currentUser?.id !== this.props.userInfo?.id) return null;

    return (
      <span className={this.props.isEditing ? 'edit-results edit-results-done' : 'edit-results'} onClick={this.props.handleResultsEditClick}>
        {this.props.isEditing ? StringConstantsMixin.strings.DONE : StringConstantsMixin.strings.EDIT}
      </span>
    );
  },
  renderCopyListButton() {
    const copyListButton = (
      <span id="clear-filters" onClick={this.props.handleCopyListClick}>
        {this.props.listCopyString}
      </span>
    );

    return copyListButton;
  },
  renderClearFiltersButton() {
    const clearFiltersButton = (
      <span id="clear-filters" onClick={this.props.clearAllFilters}>
        {StringConstantsMixin.strings.CLEAR_FILTERS}
      </span>
    );

    return clearFiltersButton;
  },
  renderResultList() {
    let resultItems = [];
    if (this.props.loading) {
      return (
        <div className="loading-placeholder">
          <LoadingSpinner />
        </div>
      );
    }
    if (this.state.results && this.state.results.length > 0) {
      if (this.props.allowReordering) {
        // if its a sortable list return a different list
        return this.renderSortableList();
      }
      this.state.results.forEach((result, idx) => {
        // Dont render unless allowed to
        if (idx >= this.state.renderableItems + renderableItemOffset) {
          return;
        }
        if (result.type == 'trail') {
          resultItems.push(this.renderTrailResultCard(result, idx));
        } else if (result.type == 'track' || result.type == 'map') {
          resultItems.push(this.renderTrackResultCard(result, idx));
        }
      });
      if (this.getResultLength() < 3 && [PageStrings.EXPLORE_ALL_PAGE, PageStrings.EXPLORE_COMMUNITY_CONTENT_PAGE].includes(this.props.currentPage)) {
        resultItems.push(this.props.noResultsObj);
      }
      if (
        this.props.currentPage === PageStrings.EXPLORE_CUSTOM_PAGE &&
        this.state.customList &&
        this.props.context.currentUser &&
        this.state.customList.userId === this.props.context.currentUser.id
      ) {
        const listPrivacyToggle = this.props.context.featureFlags.flexiblePrivacy ? (
          <PrivacyTrigger
            onClick={() => this.setState({ showModal: true })}
            label={StringConstantsMixin.strings.PROFILE.PRIVACY}
            currentOption={VISIBILITY_TO_OPTION[this.state.customList.contentPrivacy]}
          />
        ) : (
          <ListPrivacyToggle list={this.state.customList} onPrivacyChange={this.onListPrivacyChange} />
        );
        resultItems.unshift(listPrivacyToggle);
      }
    } else {
      resultItems = this.props.noResultsObj;
    }

    if (Array.isArray(resultItems)) {
      resultItems = resultItems
        .filter(item => {
          return item !== undefined && item !== null;
        })
        .map((item, pos) => {
          return <li key={`result-item${pos}`}>{item}</li>;
        });
    }

    const listFunctionalityClasses = this.getListFunctionalityClasses();
    return (
      <ul ref="scrollList" onScroll={this.handleScroll} className={listFunctionalityClasses}>
        {resultItems}
      </ul>
    );
  },
  updatePrivacyPolicy(contentPrivacy) {
    updateListPrivacy(this.state.customList.id, contentPrivacy)
      .then(list => {
        this.setState({ customList: { ...this.state.customList, contentPrivacy: list.contentPrivacy } });
      })
      .catch(logError);
  },
  renderPrivacyModal() {
    if (!this.state.showModal) return;

    return createPortal(
      <IndividualPrivacyModal
        {...policyToRadioForm(LIST, this.state.customList.contentPrivacy)}
        goBack={null}
        closeModal={() => this.setState({ showModal: false })}
        acceptCallback={this.updatePrivacyPolicy}
        isMounted
        includeModalBackground
      />,
      document.getElementById('modalPortal')
    );
  },
  render() {
    const resultList = this.renderResultList();
    let clearDiv = null;

    if (this.props.filtersSet && this.state.results) {
      clearDiv = this.renderClearFiltersButton();
    } else if (
      this.state.customList &&
      this.state.results !== null &&
      !this.props.isMobileWidth &&
      (this.props.context.currentUser === null || this.state.customList.userId !== this.props.context.currentUser.id)
    ) {
      clearDiv = this.renderCopyListButton();
    } else if (this.props.handleResultsEditClick) {
      clearDiv = this.renderEditButton();
    }

    const style = {};

    if (this.state.h1Obj && this.props.resultCountObj && !this.props.context.mobileBrowser) {
      style.paddingBottom = '64px';
    }

    let countContainer;
    if (
      this.props.resultCountObj &&
      (clearDiv ||
        this.props.currentPage === PageStrings.EXPLORE_CUSTOM_PAGE ||
        this.props.currentPage === PageStrings.EXPLORE_ALL_PAGE ||
        this.props.currentPage === PageStrings.EXPLORE_FAVORITE_PAGE ||
        this.props.currentPage === PageStrings.EXPLORE_COMPLETED_PAGE ||
        this.props.currentPage === PageStrings.EXPLORE_USERS_TRACKS_PAGE ||
        this.props.currentPage === PageStrings.EXPLORE_USERS_MAPS_PAGE)
    ) {
      countContainer = (
        <div className="count-container">
          <div className="count-container-item">{this.props.resultCountObj}</div>
          <div className="count-container-item clear-button-container">{clearDiv}</div>
        </div>
      );
    }

    let resultInfo;
    if (
      (this.state.h1Obj || countContainer) &&
      this.props.currentPage !== PageStrings.EXPLORE_ALL_PAGE &&
      this.props.currentPage !== PageStrings.EXPLORE_COMMUNITY_CONTENT_PAGE
    ) {
      resultInfo = (
        <div className="result-info">
          {this.state.h1Obj}
          {countContainer}
        </div>
      );
    }

    let bottomButtonContent;
    if (this.props.showToggleButton) {
      bottomButtonContent = (
        <div className="bottom-button-container">
          <div className="bottom-button-toggle">
            <Toggle
              name="bottomToggle"
              inputId="BottomButtonToggle"
              label={this.props.bottomButtonText}
              onChange={this.props.bottomButtonAction}
              checked={this.props.nearbyTrailsShown}
              showLabelFirst
            />
          </div>
        </div>
      );
    } else if (this.props.showBottomButton) {
      bottomButtonContent = (
        <div className="bottom-button-container" onClick={this.props.bottomButtonAction}>
          <Button onClick={this.props.bottomButtonAction} variant="primary">
            <div className="clear-filters-btn">{this.props.bottomButtonText}</div>
          </Button>
        </div>
      );
    }

    const headerBarClass = this.props.isMobileWidth ? 'hide-for-fullscreen-modal' : '';
    return (
      <div id="fullscreen-search-results" style={style} className={headerBarClass}>
        {this.props.tabBar}
        {resultInfo}
        {resultList}
        {bottomButtonContent}
        {this.renderPrivacyModal()}
      </div>
    );
  }
});

export { FullscreenSearchResultList };
